import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../common_components/StaticFooter";
import StaticHeader from "../common_components/staticHeader";
import $ from 'jquery'
import lightGallery from 'lightgallery'; 
import lgThumbnail from 'lightgallery/plugins/thumbnail'; 
import 'lightgallery/css/lightgallery.css'; 
import 'lightgallery/css/lg-thumbnail.css'; 

class PriviousEditions_2022 extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        this.loadscript()
        this.jQuery()
    }
    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }

    jQuery() {
        (function ($) {
            lightGallery(document.getElementById('selector1'), { selector: '.item', plugins: [lgThumbnail], allowMediaOverlap: true, toggleThumb: true, }); $(document).on('click', '#back-to-top, .back-to-top', () => { $('html, body').animate({ scrollTop: 0 }, '500'); return false; }); $(window).on('scroll', () => { if ($(window).scrollTop() > 500) { $('#back-to-top').fadeIn(200); } else { $('#back-to-top').fadeOut(200); } }); $('.slider-for');
        })($);
    }

    render() {
        const { } = this.state;
        return (
            <>
                <StaticHeader />
                <>
                    <div className="website">
                        <section className="banner page-banner position-relative pb-0">
                            <div className="overlay"></div>
                            <div className="container">
                                <div className="page-title text-center position-relative py-9">
                                    <h2 className="text-white text-uppercase mt-4">
                                        Previous Editions 2022
                                    </h2>
                                </div>
                            </div>
                        </section>
                        <div className="gallery py-5 mt-4">
                            <div className="container">
                                <div
                                    className="news-img mb-4"
                                    style={{ margin: "0 auto", display: "block", width: "70%" }}
                                >
                                    <img
                                        src="static/images/2nd-Edition-Awards-Invite.png"
                                        className="w-100 rounded"
                                        style={{ border: "1px solid #9f9f9f", padding: 5 }}
                                    />
                                </div>
                                <div className="galler-inner">
                                    <div className="gallerybox">
                                        <div id="selector1" className="grid row"
                                            style={{ cursor: 'pointer' }}>
                                            <div
                                                className="item grid-item col-lg-4 col-md-4 px0 mb-2 border p-0"
                                                data-src="static/images/prev4.jpg"
                                                data-lg-id="92d3a980-ceca-46ed-aeff-eef55523de3b"
                                            >
                                                <a>
                                                    <img src="static/images/prev4.jpg" className="w-100 rounded-2" />
                                                </a>
                                                <p className="text-dark px-1 pt-1 mb-1 px-2 award-text ">
                                                    Top Performance in Textile Engineering Industry - Accessories
                                                    Segment -{" "}
                                                    <span className="award-name-per">
                                                        Lakshmi Card Clothing Manufacturing Company Private Limited
                                                    </span>
                                                </p>
                                            </div>
                                            <div
                                                className="item grid-item col-lg-4 col-md-4 px0 mb-2 border p-0"
                                                data-src="static/images/prev5.jpg"
                                                data-lg-id="92d3a980-ceca-46ed-aeff-eef55523de3b"
                                            >
                                                <a>
                                                    <img src="static/images/prev5.jpg" className="w-100 rounded-2" />
                                                </a>
                                                <p className="text-dark px-1 pt-1 mb-1 px-2 award-text">
                                                    Top Performance in Textile Engineering Industry - Finishing
                                                    Segment -{" "}
                                                    <span className="award-name-per">
                                                        Texfab Engineers (India) Pvt. Ltd
                                                    </span>
                                                </p>
                                            </div>
                                            <div
                                                className="item grid-item col-lg-4 col-md-4 px0 mb-2 border p-0"
                                                data-src="static/images/prev6.jpg"
                                                data-lg-id="92d3a980-ceca-46ed-aeff-eef55523de3b"
                                            >
                                                <a>
                                                    <img src="static/images/prev6.jpg" className="w-100 rounded-2" />
                                                </a>
                                                <p className="text-dark px-1 pt-1 mb-1 px-2 award-text">
                                                    Top Performance in Textile Engineering Industry -{" "}
                                                    <span className="award-name-per">
                                                        Printing Segment ColorJet India Ltd
                                                    </span>
                                                </p>
                                            </div>
                                            <div
                                                className="item grid-item col-lg-4 col-md-4 px0 mb-2 border p-0 mt-3"
                                                data-src="static/images/prev7.jpg"
                                                data-lg-id="92d3a980-ceca-46ed-aeff-eef55523de3b"
                                            >
                                                <a>
                                                    <img src="static/images/prev7.jpg" className="w-100 rounded-2" />
                                                </a>
                                                <p className="text-dark px-1 pt-1 mb-1 px-2 award-text">
                                                    Top Performance in Textile Engineering Industry - Spinning
                                                    Segment -{" "}
                                                    <span className="award-name-per">
                                                        {" "}
                                                        Lakshmi Machine Works Limited
                                                    </span>
                                                </p>
                                            </div>
                                            <div
                                                className="item grid-item col-lg-4 col-md-4 px0 mb-2 border p-0 mt-3"
                                                data-src="static/images/prev8.jpg"
                                                data-lg-id="92d3a980-ceca-46ed-aeff-eef55523de3b"
                                            >
                                                <a>
                                                    <img src="static/images/prev8.jpg" className="w-100 rounded-2" />
                                                </a>
                                                <p className="text-dark px-1 pt-1 mb-1 px-2 award-text">
                                                    Top Performance in Textile Engineering Industry - Weaving &amp;
                                                    Preparatory Segment -
                                                    <span className="award-name-per"> Rabatex Industries</span>
                                                </p>
                                            </div>
                                            <div
                                                className="item grid-item col-lg-4 col-md-4 px0 mb-2 border p-0 mt-3"
                                                data-src="static/images/prev9.jpg"
                                                data-lg-id="92d3a980-ceca-46ed-aeff-eef55523de3b"
                                            >
                                                <a>
                                                    <img src="static/images/prev9.jpg" className="w-100 rounded-2" />
                                                </a>
                                                <p className="text-dark px-1 pt-1 mb-1 px-2 award-text">
                                                    Best Initiatives for Pollution Control Technology -{" "}
                                                    <span className="award-name-per">
                                                        S. A. Pharmachem Pvt. Ltd.
                                                    </span>
                                                </p>
                                            </div>
                                            <div
                                                className="item grid-item col-lg-4 col-md-4 px0 mb-2 border p-0 mt-3"
                                                data-src="static/images/prev10.jpg"
                                                data-lg-id="92d3a980-ceca-46ed-aeff-eef55523de3b"
                                            >
                                                <a>
                                                    <img src="static/images/prev10.jpg" className="w-100 rounded-2" />
                                                </a>
                                                <p className="text-dark px-1 pt-1 mb-1 px-2 award-text">
                                                    Special Award for Women Entrepreneur -{" "}
                                                    <span className="award-name-per">
                                                        Ms. Deepa Kumar, Founder &amp; CEO of Yashram Lifestyle Brands
                                                    </span>
                                                </p>
                                            </div>
                                            <div
                                                className="item grid-item col-lg-4 col-md-4 px0 mb-2 border p-0 mt-3"
                                                data-src="static/images/prev11.jpg"
                                                data-lg-id="92d3a980-ceca-46ed-aeff-eef55523de3b"
                                            >
                                                <a>
                                                    <img src="static/images/prev11.jpg" className="w-100 rounded-2" />
                                                </a>
                                                <p className="text-dark px-1 pt-1 mb-0 px-2 award-text">
                                                    Special Award for Women Nurturing Women Empowerment -{" "}
                                                    <span className="award-name-per">
                                                        Ms. Neha Jhunjhunwala, Director, Sarla Performance Fibers Ltd.
                                                    </span>
                                                </p>
                                            </div>
                                            <div
                                                className="item grid-item col-lg-4 col-md-4 px0 mb-2 border p-0 mt-3"
                                                data-src="static/images/prev12.jpg"
                                                data-lg-id="92d3a980-ceca-46ed-aeff-eef55523de3b"
                                            >
                                                <a>
                                                    <img src="static/images/prev12.jpg" className="w-100 rounded-2" />
                                                </a>
                                                <p className="text-dark px-1 pt-1 mb-1 px-2 award-text">
                                                    Special Award for Women Restoring Traditional Skills -{" "}
                                                    <span className="award-name-per"> Ms. Kumari Raita</span>
                                                </p>
                                            </div>
                                            <div
                                                className="item grid-item col-lg-4 col-md-4 px0 mb-2 border p-0 mt-3"
                                                data-src="static/images/prev13.jpg"
                                                data-lg-id="92d3a980-ceca-46ed-aeff-eef55523de3b"
                                            >
                                                <a>
                                                    <img src="static/images/prev13.jpg" className="w-100 rounded-2" />
                                                </a>
                                                <p className="text-dark px-1 pt-1 mb-1 px-2 award-text">
                                                    Special Award for Woman Master Weaver -{" "}
                                                    <span className="award-name-per"> Ms. Santoshi Kewat</span>
                                                </p>
                                            </div>
                                            <div
                                                className="item grid-item col-lg-4 col-md-4 px0 mb-2 border p-0 mt-3"
                                                data-src="static/images/prev14.jpg"
                                                data-lg-id="92d3a980-ceca-46ed-aeff-eef55523de3b"
                                            >
                                                <a>
                                                    <img src="static/images/prev14.jpg" className="w-100 rounded-2" />
                                                </a>
                                                <p className="text-dark px-1 pt-1 mb-1 px-2 award-text">
                                                    Research Excellence -{" "}
                                                    <span className="award-name-per">
                                                        {" "}
                                                        Dr. Rekha Ramakrishnan from SASMIRA
                                                    </span>
                                                </p>
                                            </div>
                                            <div
                                                className="item grid-item col-lg-4 col-md-4 px0 mb-2 border p-0 mt-3"
                                                data-src="static/images/prev15.jpg"
                                                data-lg-id="92d3a980-ceca-46ed-aeff-eef55523de3b"
                                            >
                                                <a>
                                                    <img src="static/images/prev15.jpg" className="w-100 rounded-2" />
                                                </a>
                                                <p className="text-dark px-1 pt-1 mb-1 px-2 award-text">
                                                    Textile Maestro -{" "}
                                                    <span className="award-name-per">
                                                        {" "}
                                                        Mr. S P Oswal, Chairman &amp; Managing Director, Vardhman
                                                        Group of Companies (A representative received the award on his
                                                        behalf)
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                </>

                <StaticFooter />
                <ToastContainer />
            </>
        )
    }
}
export default withRouter(
    connect(null, {})(PriviousEditions_2022)
);
